import { createSlice } from '@reduxjs/toolkit';

export const systemSlice = createSlice({
  name: 'system',
  initialState: {
    collapsed: false,
    isFullscreen: false,
    visible: false,
    images: [],
  },
  reducers: {
    // 展开菜单
    onCollapsed: (state) => {
      state.collapsed = !state.collapsed;
    },
    // 全屏模式
    onFullscreen: (state, { payload }) => {
      state.isFullscreen = payload;
    },
    // 全局预览图片
    onImagePreview: (state, { payload }) => {
      state.visible = payload.visible;
      if (state.visible) {
        state.images = payload.images;
        return;
      }
      state.images = [];
    },
  },
});

// 每个 case reducer 函数会生成对应的 Action creators
export const { onCollapsed, onFullscreen, onImagePreview } = systemSlice.actions;

export default systemSlice.reducer;
